(() => {
  const init = () => {
    const root = document.querySelector('[data-dermana-product]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const copy = root.dataset;
    const sticky = root.querySelector('[data-dermana-sticky]');
    const radios = [...root.querySelectorAll('[data-variant-radio]')];
    const stock = root.querySelector('[data-stock-status]');
    const pad = n => String(n).padStart(2, '0');
    const formatClock = n => `${pad(Math.floor(n / 3600))}:${pad(Math.floor(n % 3600 / 60))}:${pad(n % 60)}`;
    const shippingState = now => {
      const turkey = new Date(now.getTime() + 10800000);
      const target = new Date(Date.UTC(turkey.getUTCFullYear(), turkey.getUTCMonth(), turkey.getUTCDate(), 10));
      while (target <= now || target.getUTCDay() === 0 || target.getUTCDay() === 6) target.setUTCDate(target.getUTCDate() + 1);
      const next = new Date(target.getTime() + 10800000);
      return { today: next.getUTCDate() === turkey.getUTCDate() && next.getUTCMonth() === turkey.getUTCMonth(), seconds: Math.max(0, Math.floor((target - now) / 1000)) };
    };
    const tickShipping = () => {
      const state = shippingState(new Date());
      root.querySelector('[data-ship-text]').textContent = state.today ? copy.shipToday : copy.shipNext;
      root.querySelectorAll('[data-ship-clock]').forEach(clock => { clock.textContent = formatClock(state.seconds); });
    };
    tickShipping();
    const shippingInterval = setInterval(tickShipping, 1000);
    const updateStock = () => {
      const selected = radios.find(r => r.checked);
      if (!selected || !stock) return;
      const qty = Number(selected.dataset.inventory);
      if (selected.dataset.tracked !== 'true' || !Number.isFinite(qty) || qty <= 0) { stock.hidden = true; return; }
      let peak = qty;
      try {
        const key = 'dermana_stock_peak_v1';
        const stored = JSON.parse(localStorage.getItem(key) || '{}');
        peak = Math.max(qty, Number(stored[selected.value]) || qty);
        stored[selected.value] = peak;
        localStorage.setItem(key, JSON.stringify(stored));
      } catch (_) {}
      stock.querySelector('[data-stock-count]').textContent = `${qty} ${copy.stockUnit}`;
      const meter = stock.querySelector('[data-stock-meter]');
      meter.max = peak; meter.value = qty; meter.textContent = `${qty} / ${peak}`;
      stock.hidden = false;
    };
    radios.forEach(r => r.addEventListener('change', updateStock));
    updateStock();
    const openCod = () => {
      const button = document.getElementById('rsi_buy_now_button');
      if (button && button.getAttribute('aria-disabled') !== 'true' && !button.disabled) { button.click(); return; }
      const form = root.querySelector('.dpd-actions');
      form?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
      if (!root.querySelector('.dmr-cod-notice')) {
        const notice = document.createElement('p'); notice.className = 'dmr-cod-notice'; notice.setAttribute('role', 'status'); notice.textContent = copy.codError; form?.after(notice);
      }
    };
    root.querySelector('[data-sticky-atc]')?.addEventListener('click', openCod);
    let frame;
    const updateSticky = () => {
      frame = undefined;
      const submit = document.querySelector('#rsi_form_wrapper .rsi-submit_button');
      if (submit && !submit.parentElement.querySelector('.dmr-form-trust')) {
        const trust = document.createElement('p'); trust.className = 'dmr-form-trust'; trust.textContent = root.querySelector('.dmr-return-trust')?.textContent || '';
        if (trust.textContent) submit.after(trust);
      }
      const primaryButton = document.getElementById('rsi_buy_now_button');
      const rect = primaryButton?.getBoundingClientRect();
      const popupOpen = document.querySelector('[data-dmr-exit][open]') || document.querySelector('#rsi_form_wrapper[open]');
      const hasPrimary = Boolean(rect && rect.height > 0 && primaryButton?.offsetParent !== null);
      const passedPrimary = hasPrimary && rect.bottom <= 0;
      const visible = matchMedia('(max-width: 749px)').matches && passedPrimary && !popupOpen;
      if (sticky && sticky.classList.contains('is-visible') !== Boolean(visible)) sticky.classList.toggle('is-visible', Boolean(visible));
    };
    const scheduleSticky = () => { if (!frame) frame = requestAnimationFrame(updateSticky); };
    window.addEventListener('scroll', scheduleSticky, { passive: true });
    window.addEventListener('resize', scheduleSticky);
    const observer = new MutationObserver(scheduleSticky);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'open'] });
    updateSticky();
    const exitKey = 'dermana_exit_shown_v2';
    let shown = false;
    try { shown = sessionStorage.getItem(exitKey) === '1'; } catch (_) {}
    const dialog = document.createElement('dialog'); dialog.className = 'dmr-exit'; dialog.dataset.dmrExit = ''; dialog.setAttribute('aria-labelledby', 'dermana-exit-title');
    const box = document.createElement('div'); box.className = 'dmr-exit__box';
    const closeButton = document.createElement('button'); closeButton.type = 'button'; closeButton.className = 'dmr-exit__x'; closeButton.setAttribute('aria-label', copy.close); closeButton.textContent = '×';
    const kicker = document.createElement('span'); kicker.className = 'dmr-exit__kicker'; kicker.textContent = copy.exitKicker;
    const title = document.createElement('h3'); title.id = 'dermana-exit-title'; title.textContent = copy.exitTitle;
    const body = document.createElement('p'); body.textContent = copy.exitBody;
    const cta = document.createElement('button'); cta.type = 'button'; cta.className = 'dmr-exit__cta'; cta.textContent = copy.exitCta;
    const no = document.createElement('button'); no.type = 'button'; no.className = 'dmr-exit__no'; no.textContent = copy.exitNo;
    box.append(closeButton, kicker, title, body, cta, no); dialog.append(box); document.body.append(dialog);
    const close = () => { dialog.close(); updateSticky(); };
    closeButton.addEventListener('click', close); no.addEventListener('click', close);
    dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
    dialog.addEventListener('close', updateSticky);
    cta.addEventListener('click', () => { close(); openCod(); });
    document.addEventListener('mouseout', event => {
      if (shown || event.clientY > 0 || event.relatedTarget || !matchMedia('(hover: hover)').matches || document.querySelector('#rsi_form_wrapper[open]')) return;
      shown = true;
      try { sessionStorage.setItem(exitKey, '1'); } catch (_) {}
      dialog.showModal(); updateSticky();
    });
    window.addEventListener('pagehide', () => { clearInterval(shippingInterval); observer.disconnect(); }, { once: true });
    window.addEventListener('pageshow', event => { if (event.persisted) location.reload(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
